/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_RangeInputs */

const en_event_range = /** @type {(inputs: Event_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Range`)
};

const fr_event_range = /** @type {(inputs: Event_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plage d’événements`)
};

const de_event_range = /** @type {(inputs: Event_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltungsbereich`)
};

const it_event_range = /** @type {(inputs: Event_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervallo di eventi`)
};

const ru_event_range = /** @type {(inputs: Event_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Диапазон событий`)
};

const es_event_range = /** @type {(inputs: Event_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rango de eventos`)
};

const zh_cn2_event_range = /** @type {(inputs: Event_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件范围`)
};

const ja_event_range = /** @type {(inputs: Event_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント範囲`)
};

const hi_event_range = /** @type {(inputs: Event_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घटना सीमा`)
};

const pt_pt2_event_range = /** @type {(inputs: Event_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faixa de eventos`)
};

/**
* | output |
* | --- |
* | "Event Range" |
*
* @param {Event_RangeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_range = /** @type {((inputs?: Event_RangeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_RangeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_range(inputs)
	if (locale === "de") return de_event_range(inputs)
	if (locale === "it") return it_event_range(inputs)
	if (locale === "ru") return ru_event_range(inputs)
	if (locale === "es") return es_event_range(inputs)
	if (locale === "zh-CN") return zh_cn2_event_range(inputs)
	if (locale === "ja") return ja_event_range(inputs)
	if (locale === "hi") return hi_event_range(inputs)
	if (locale === "pt-PT") return pt_pt2_event_range(inputs)
	return en_event_range(inputs)
});